export enum AuthErrorEnum {
  NoEmail = 'no_email',
  EmailVerification = 'verify_email',
  UnsupportedTenant = 'unsupported_tenant',
  NoCiam = 'no_ciam',
  Default = 'default',
}
export interface AuthErrorPropsInterface {
  type: AuthErrorEnum;
  error: string;
  state: string;
}
